// Navbars.js
import React, { useState } from "react";
import { Link } from "react-router-dom";

const Navbars = () => {
  const [background, setBackground] = useState("");

  const changeWallpaper = (url) => {
    document.body.style.backgroundImage = `url('${url}')`;
  };

  return (
    <>
      <header className="relative top-7">
        <nav class="flex justify-center">
          <ul class="flex items-center justify-center space-x-9 h-14 w-112 bg-[#1e0a3c] border-blue-400 rounded-full border-2 text-white">
            <Link to="Home">
              <li class="transition ease-in-out hover:text-blue-400 hover:underline decoration-2 underline-offset-4">
                HOME
              </li>
            </Link>
            <Link to="About">
              <li class="transition ease-in-out hover:text-blue-400 hover:underline decoration-2 underline-offset-4">
                ABOUT
              </li>
            </Link>
            <Link to="">
              <li class="transition ease-in-out hover:text-blue-400 hover:underline decoration-2 underline-offset-4">
                CONTACT
              </li>
            </Link>
            <Link to="Themone">
              <li class="transition ease-in-out hover:text-blue-400 hover:underline decoration-2 underline-offset-4">
                SERVES
              </li>
            </Link>
          </ul>
        </nav>
      </header>

      <div className="flex justify-center mt-14 max-md:hidden">
        <Link
          to="#"
          className="text-white mr-2 font-bold underline-offset-4 decoration-4 text-base hover:text-slate-300 active:text-red-400 hover:underline"
          onClick={(e) => {
            e.preventDefault();
            changeWallpaper(
              "https://i.postimg.cc/B65RzhVJ/url-to-wallpaper-1.jpg"
            );
          }}
        >
          Jujutsu Kaisen
        </Link>
        <Link
          to="#"
          className="text-white mr-2 font-bold underline-offset-4 decoration-4 text-base hover:text-slate-300 active:text-red-400 hover:underline"
          onClick={(e) => {
            e.preventDefault();
            changeWallpaper(
              "https://i.postimg.cc/L5Nw9JS7/url-to-wallpaper-2.jpg"
            );
          }}
        >
          One pace
        </Link>
        <Link
          to="#"
          className="text-white mr-2 font-bold underline-offset-4 decoration-4 text-base hover:text-slate-300 active:text-red-400 hover:underline"
          onClick={(e) => {
            e.preventDefault();
            changeWallpaper(
              "https://i.postimg.cc/3JxzLFCH/url-to-wallpaper-3.png"
            );
          }}
        >
          Demon slayer
        </Link>
        <Link
          to="#"
          className="text-white mr-2 font-bold underline-offset-4 decoration-4 text-base hover:text-slate-300 active:text-red-400 hover:underline"
          onClick={(e) => {
            e.preventDefault();
            changeWallpaper("https://example.com/wallpaper4.jpg");
          }}
        >
          mountain
        </Link>
      </div>
    </>
  );
};

export default Navbars;
